import styled from "styled-components/macro";

export const ImgSt = styled.img`
  grid-area: st;
`;